import VettedCheckmark from '../../src/legacy/VettedCheckmark';
export default VettedCheckmark;
